import React from 'react';
import { Anohana, Bx, Btn, IconBtn, Typo } from '@curry-group/mui-curcuma';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowToRight, faTimes } from '@fortawesome/pro-light-svg-icons';
import { HeadlineContainer } from '../headline-container';

export const GeneralModal: React.FC<{ 
  open: boolean;
  headline: string;
  content: string;
  commitText?: string;
  cancelText?: string;
  /** Shows the confirm button but disabled — e.g. while a precondition is unmet. */
  commitDisabled?: boolean;
  close: () => void;
  cancel: () => void;
  commit: () => void
}> = ({
  open,
  headline,
  content,
  commitText,
  cancelText,
  commitDisabled,
  close,
  cancel,
  commit
}) => {
  return (
    <Anohana open={open} fullWidth maxWidth="sm">
      <HeadlineContainer
        bgcolor="background.paper"
        px={3}
        py={2.5}
        headline={headline}
        minHeight={81}
        headlineVariant="h4"
        headlineComponent="h5"
        endAdornment={<IconBtn size="small" onClick={close}><FontAwesomeIcon icon={faTimes} /></IconBtn>}
      />
      <Bx py={3} px={3}>
        {content && <Typo variant="body1">{content}</Typo>}
        <Bx mt={2} display="flex" justifyContent="flex-end" alignItems="center">
          <Bx>
            <Btn onClick={commit} disabled={!!commitDisabled} color="success" size="large" variant="contained" startIcon={<FontAwesomeIcon icon={faArrowToRight} />}>
              {commitText || 'OK'}
            </Btn>
          </Bx>
          <Bx ml={1}>
            <Btn onClick={cancel} color="error" size="large" variant="contained" startIcon={<FontAwesomeIcon icon={faTimes} />}>
              {cancelText || 'Abbrechen'}
            </Btn>
          </Bx>
        </Bx>
      </Bx>
    </Anohana>
  );
};
